module.exports = __webpack_public_path__ + "static/media/profile.b88dcb80.svg";